import { type ProgramEventContentObjectDetail, getLastChangeRequestStatus } from 'models';
import { usePermissions } from 'permissions';
import { Alert, Card } from 'ui';
import { useGetAlertMessageContent } from './hooks';

type P = {
  eventContentObject: ProgramEventContentObjectDetail;
};

const ProgramEventDetailStatusMessage = ({ eventContentObject }: P) => {
  const { event } = eventContentObject;
  const { canViewEventApprovalStatus } = usePermissions();
  const status = getLastChangeRequestStatus(event.changeRequests);
  const message = useGetAlertMessageContent({
    eventStatus: event.status,
    status,
  });

  if (!canViewEventApprovalStatus({ eventContentObject }) || !message) {
    return null;
  }

  return (
    <Card>
      <Alert description={message.description} icon={message.icon} title={message.title} type={message.type} />
    </Card>
  );
};

export default ProgramEventDetailStatusMessage;
